module.exports = __webpack_public_path__ + "img/serial-location.24852a81.png";